import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={22} height={23} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.514 10.915C9.514 7.017 8.126 0 8.126 0L22 16.763C14.42 21.293 9.114 22.74 0 23c3.963-3.163 9.514-8.186 9.514-12.085z" /></svg>;
}
export default SvgComponent;